// Based on theme contract specified in styleguide/colors
// must match with the theme name in the color styleguide
const Themes = ['light', 'dark', 'inherit'];
function applyTheme(theme) {
    if (!theme)
        return '';
    if (theme === 'inherit')
        return '';
    return `sg-${theme}-theme`;
}

export { Themes, applyTheme };
//# sourceMappingURL=Theme.js.map
